export default "__VITE_ASSET__63273051__"